import React from "react";
import "../styles/components/DecibelMeter.css";

interface DecibelMeterProps {
  volumeLevel: number; // Value between 0 and 1
}

const DecibelMeter: React.FC<DecibelMeterProps> = ({ volumeLevel }) => {
  // Number of chicklets to display
  const totalChicklets = 12;
  
  // Calculate how many chicklets should be active based on the volume level
  const activeChickletsCount = Math.ceil(volumeLevel * totalChicklets);
  
  // Generate the chicklets array
  const chicklets = Array.from({ length: totalChicklets }, (_, index) => {
    const isActive = index < activeChickletsCount;
    
    // Determine chicklet color class based on its position
    let colorClass = "low";
    if (index >= totalChicklets * 0.7) {
      colorClass = "high";
    } else if (index >= totalChicklets * 0.4) {
      colorClass = "medium";
    }
    
    return (
      <div 
        key={index} 
        className={`chicklet ${colorClass} ${isActive ? "active" : ""}`}
      />
    );
  });

  return (
    <>
      {chicklets}
    </>
  );
};

export default DecibelMeter;
